import styled from 'styled-components';
import { X } from 'lucide-react';

export default function AccountUpgradeModal({ isOpen, onUpgrade, onDismiss }) {
  if (!isOpen) return null;

  return (
    <Overlay onClick={onDismiss}>
      <Modal onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onDismiss}>
          <X size={20} />
        </CloseButton>
        
        <Content>
          <Emoji>🎨</Emoji>
          <Title>Nice work!</Title>
          <Text>Sign in with Google to save your art and keep playing with your circle.</Text>
          
          <Actions>
            <UpgradeButton onClick={onUpgrade}>Sign in with Google</UpgradeButton>
            <DismissButton onClick={onDismiss}>Maybe later</DismissButton>
          </Actions>
        </Content>
      </Modal>
    </Overlay>
  );
}

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

const Modal = styled.div`
  background: ${({ theme }) => theme.colors.surfaceElevated};
  border-radius: ${({ theme }) => theme.radius.large};
  max-width: 400px;
  width: 100%;
  position: relative;
  box-shadow: ${({ theme }) => theme.shadows.large};
`;

const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 8px;
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.textSecondary};
  transition: all 0.2s;

  &:hover {
    background: ${({ theme }) => theme.colors.surface};
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`;

const Content = styled.div`
  padding: 32px 24px 24px;
  text-align: center;
`;

const Emoji = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
`;

const Title = styled.h2`
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 12px;
`;

const Text = styled.p`
  font-size: 15px;
  color: ${({ theme }) => theme.colors.textSecondary};
  line-height: 1.5;
  margin-bottom: 24px;
`;

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const UpgradeButton = styled.button`
  padding: 14px 32px;
  border-radius: ${({ theme }) => theme.radius.medium};
  background: ${({ theme }) => theme.colors.accent};
  color: white;
  font-size: 17px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
  transition: all 0.2s;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(245, 158, 11, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

const DismissButton = styled.button`
  padding: 12px 24px;
  border-radius: ${({ theme }) => theme.radius.medium};
  background: transparent;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 15px;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    color: ${({ theme }) => theme.colors.textPrimary};
    background: ${({ theme }) => theme.colors.surface};
  }
`;
